import React from 'react'

interface FilterChipProps {
  label: string
  onRemove: () => void
  /** Optional accent color — sets border, text, and tinted background */
  color?: string
  /** Optional emoji/icon shown before the label */
  icon?: string
  style?: React.CSSProperties
  className?: string
}

export const FilterChip: React.FC<FilterChipProps> = ({ label, onRemove, color, icon, style, className }) => (
  <div
    className={className}
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: '0.3rem',
      padding: '0.2rem 0.35rem 0.2rem 0.55rem',
      background: color ? `${color}18` : 'var(--bg-elevated)',
      border: `1.5px solid ${color ?? 'var(--border)'}`,
      borderRadius: '20px',
      fontSize: '0.78rem',
      fontWeight: color ? 500 : 400,
      color: color ?? 'var(--text-secondary)',
      whiteSpace: 'nowrap',
      ...style,
    }}
  >
    {icon && <span style={{ fontSize: '0.85rem', lineHeight: 1 }}>{icon}</span>}
    {label}
    <button
      type="button"
      onClick={onRemove}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '16px',
        height: '16px',
        borderRadius: '50%',
        border: 'none',
        background: 'transparent',
        color: color ?? 'var(--text-muted)',
        cursor: 'pointer',
        fontSize: '0.7rem',
        padding: 0,
        lineHeight: 1,
        flexShrink: 0,
        transition: 'color 0.15s, background 0.15s',
      }}
      onMouseEnter={e => { (e.currentTarget as HTMLButtonElement).style.background = 'rgba(0,0,0,0.12)' }}
      onMouseLeave={e => { (e.currentTarget as HTMLButtonElement).style.background = 'transparent' }}
      aria-label={`Remove ${label}`}
    >
      ✕
    </button>
  </div>
)
